import { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

// utils
import * as constants from '../Utils/constants';
import { URLS } from '../Utils/constants';
import { AppIdContext } from '../Contexts/AppIdContext';
import LfDataService from '../../../Services/LfDataService.js';

//components
import QuestionHeader from '../../PensionInsuranceWizardBlock/Components/Wizard/QuestionHeader'
import doneImg from '/images/done-circle.svg'
import bankIdImg from '/images/BankID.svg'


const lfDataService = new LfDataService();

/**
 * Starts the signing process for the managed pension application.
 * 
 * @param {string} appId Application id from context.
 */


function checkIfSigned(appId) {
    return lfDataService.getManagedPensionApplicationBankIDStatus({ appId: appId })
        .then(result => {
            return result.signed;
        })
}

const Start = () => {

    const [isSigned, setIsSigned] = useState(null);

    const navigate = useNavigate();
    const id = useContext(AppIdContext);

    useEffect(() => {
        if (id) {
            checkIfSigned(id).then(signed => {
                setIsSigned(signed)
                if (signed === true) {
                    navigate(URLS.resultSuccess)
                }
            })
        }
    }, [id])

    if (isSigned === null) {
        return null;
    }

    return (
            <div className="signature-process">
                <div className="signature-process__container">

                        <div className="pension-wizard-block__question pension-wizard-block__question__sign">
                            <div className="pension-wizard-block__question__card">
                                <div className="pension-wizard-block__question__sign__illustration">
                                    <img
                                        src={doneImg}
                                        alt=''
                                    />
                                </div>
                                <QuestionHeader
                                    id={id}
                                    showCount={false}
                                    showApplication={true}
                                    headline={constants.start.headline}
                                    text={constants.start.text}
                                />
                                <button
                                  type="button" onClick={() => navigate(URLS.selectMethod)}
                                    className="button button--green">
                                    <span className="bankid-icon">
                                        <img
                                            src={bankIdImg}
                                            alt=''
                                        />
                                    </span>
                                    {constants.start.buttonText}
                                </button>
                            </div>
                    </div>
                </div>
            </div>  

      )
}


export default Start;

